// Auto-refactored from translations.js on 2026-08-19
// Locale: es

const es = {
  wieMoeglich: { question: '¿Cómo es posible?', answer: 'Hemos repensado la cadena de valor.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'El camino STIG ROCK',
    fazit: 'La cadena de suministro acortada elimina las mayores posiciones de coste.',
    fazitBigPre: 'Esto permite un descuento de hasta',
    fazitBigValue: '80%',
    steps: [ 'Mina', 'Taller de talla', 'Certificación', 'Cliente final' ]
  },
  nav: { language: 'Idioma', contact: 'Contacto' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Una oportunidad única',
    subtitle: 'Construir patrimonio con visión de futuro.',
    description: 'STIG ROCK es una plataforma internacional que ofrece a las personas acceso a diamantes naturales, creación de patrimonio sostenible y una comunidad única.',
    scroll: 'Desplázate para descubrir'
  },
  disclaimer: {
    overline: 'Aviso legal',
    title: 'Disclaimer',
    paragraphs: [
      'Esta presentación es meramente informativa y no constituye asesoramiento financiero, de inversión ni fiscal.',
      'STIG ROCK no es un producto financiero, sino que se refiere a diamantes naturales como activos tangibles.',
      'No se garantiza ninguna revalorización, beneficio ni rendimiento. Los resultados pasados no son indicativos de resultados futuros.',
      'Todos los cálculos presentados en relación con las comisiones son meramente ilustrativos y tampoco constituyen garantía alguna.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'CONSTRUIDO', 'SOBRE ESTRUCTURA' ],
    body: 'STIG Group es un conglomerado internacional construido sobre claridad, responsabilidad y valor a largo plazo. Cada marca, cada proyecto y cada alianza sigue un único estándar — sin atajos, sin excepciones.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'CONSTRUIDO', 'SOBRE ESTRUCTURA' ],
        body: 'STIG Group es un conglomerado internacional construido sobre claridad, responsabilidad y valor a largo plazo. Cada marca, cada proyecto y cada alianza sigue un único estándar — sin atajos, sin excepciones.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'EL MUNDO', 'DE DIAMANTES EXCLUSIVOS' ],
        body: 'STIG ROCK es un concepto moderno de STIG Group que combina diamantes GIA certificados de alta calidad con estructuras transparentes y una experiencia de cliente exclusiva. Soluciones claras, gestión profesional y proyección internacional.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'COMERCIO', 'INTERNACIONAL DE DIAMANTES' ],
        body: 'STIG International es parte de STIG Group y está especializada en el comercio internacional de diamantes certificados GIA. Foco en calidad, confianza y estructuras comerciales modernas con alianzas globales.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'RESPONSABILIDAD', 'DESDE LA MINA' ],
        body: 'Ethical Mines representa extracción responsable, trazabilidad de origen y diamantes libres de conflicto. Desde la mina hasta el mercado — documentación completa para transparencia, integridad y responsabilidad a largo plazo en toda la cadena de suministro.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamantes',
    stigDrawback: 'Depósito de valor real',
    overline: 'Posibilidades',
    title: 'Posibilidades para la construcción de patrimonio',
    subtitle: 'Vías convencionales en comparación.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex o cripto',
        drawback: 'altamente especulativo, impredecible, complejo'
      },
      {
        tag: 'Acciones',
        name: 'Operativa en bolsa',
        drawback: 'riesgo de volatilidad, conocimiento necesario, dedicación'
      },
      {
        tag: 'Cripto',
        name: 'Negociación',
        drawback: 'volatilidad, riesgo regulatorio, brechas de seguridad'
      }
    ]
  },
  chance: {
    overline: 'Diamantes',
    title: 'La oportunidad subestimada',
    body: 'Los diamantes se cuentan desde hace años entre las formas de inversión más estables y con mayor potencial, pero hasta ahora solo unos pocos han aprovechado este potencial.',
    callout: 'Con nuestra STIG ROCK abrimos por primera vez el acceso a estas oportunidades excepcionales para todos.'
  },
  wertentwicklung: {
    overline: 'Revalorización 1995 — 2025',
    title: 'Una historia sobre valor.',
    usd: 'Dólar estadounidense',
    usdValue: '-49%',
    diamond: 'Diamantes',
    diamondValue: '+185%',
    note: 'Evolución desde 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Razones principales',
    title: 'Seis razones para los diamantes',
    lead: 'Los diamantes son activos tangibles reales que existen independientemente de las monedas y los sistemas financieros — y han conservado su valor durante siglos.',
    items: [
      {
        n: '01',
        title: 'Estabilidad de valor a prueba de crisis',
        body: 'Garantía de activo tangible. Independiente de monedas y sistemas financieros.'
      },
      {
        n: '02',
        title: 'La máxima movilidad',
        body: 'Pequeños, fáciles de ocultar y transportar.'
      },
      {
        n: '03',
        title: 'Diversificación y escasez',
        body: 'Restricciones de oferta y limitación natural.'
      },
      { n: '04', title: 'Crecimiento a largo plazo', body: '+185% desde 1995.' },
      {
        n: '05',
        title: 'Transparencia y exclusividad',
        body: 'Las 4 Cs como garantía: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Reserva de las casas reales',
        body: 'Incluso las casas reales utilizan diamantes como reserva patrimonial.'
      }
    ]
  },
  markt: {
    overline: 'Volumen de mercado',
    title: '99 — 108 mil millones USD',
    sub: 'Volumen de negocio en el año 2025',
    forecast: 'Previsión hasta ~2032 / 2034: aprox. 140 – 168 mil millones USD con crecimiento moderado (~4 – 5 % anual).',
    source: 'Fuente: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Innovación',
    title: 'Una innovación. Por primera vez a nivel mundial.',
    body: 'STIG ROCK es la primera plataforma del mundo que permite a las personas generar ingresos pasivos en el mercado de diamantes, además de la revalorización.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, EAU',
      'N.º de registro DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'Sobre la empresa',
    titleLines: [ 'ESTRUCTURA', 'INTERNACIONAL', 'VISIÓN CLARA' ],
    body: 'STIG ROCK fue fundada para hacer el mercado de diamantes más transparente, moderno y orientado al cliente — con foco en confianza, seguridad y estructura a largo plazo.'
  },
  sicherheit: {
    overline: 'Calidad y seguridad',
    title: 'Gemological Institute of America',
    body: 'Experiencia certificada para sus diamantes. GIA evalúa cada piedra con máxima precisión y años de experiencia — valoraciones fiables para nuestra empresa y nuestros clientes.',
    transparency: 'Cada diamante cumple los más altos estándares de calidad y es examinado y certificado por organizaciones de renombre. Cada piedra es única y recibe un certificado individual.',
    kimberley: 'Kimberley Process — trabajamos exclusivamente con diamantes libres de conflicto.'
  },
  plaene: {
    overline: 'Solution Plans (SP)',
    title: 'Una innovación de producto única',
    sub: 'Seis Solution Plans escalonados — desde $1K hasta $100K+, cada uno con descuento creciente por mes y sobre la duración total.',
    recommended: 'Popular',
    oneYear: '1 año',
    rowLabels: {
      delivery: 'Plazo de entrega',
      price: 'Precio del producto',
      carat: 'Quilates',
      monthly: 'Descuento (mes)',
      totalDiscount: 'Descuento (total)',
      duration: 'Duración'
    },
    headers: {
      plan: 'Plan',
      from: 'Desde',
      carat: 'Quilates',
      monthly: 'Descuento / mes',
      total: 'Descuento total',
      duration: 'Duración'
    },
    duration: '1 año',
    footnote: 'Todos los precios están sujetos a cambios y dependen de la calidad, la demanda y la evolución actual del mercado. Los planes Solution también son posibles a 2 años.'
  },
  plaeneVIP: {
    overline: 'Solution Plans + Paquete VIP',
    title: 'Con paquete VIP aún más descuento',
    sub: 'Descuento total por plan — combinado con un paquete VIP obtienes +1% hasta +3% adicional, lo que aumenta notablemente el descuento total.',
    rowLabels: {
      delivery: 'Plazo de entrega',
      price: 'Precio del producto',
      carat: 'Quilates',
      monthly: 'Descuento (mes)',
      totalDiscount: 'Descuento (total)',
      vip1: 'Paquete VIP 1 (+1%)',
      vip2: 'Paquete VIP 2 (+2%)',
      vip3: 'Paquete VIP 3 (+3%)'
    },
    footnote: 'Todos los precios están sujetos a cambios y dependen de la calidad, la demanda y la evolución actual del mercado.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Tus opciones',
    sub: 'Al finalizar tu plan Solution puedes revender tus diamantes a nosotros o hacer que te los envíen a casa.',
    options: [
      {
        key: 'deliver',
        title: 'Envío a domicilio',
        body: 'Diamantes (quilates) al precio de tu DS-Plan*'
      },
      {
        key: 'sellToUs',
        title: 'Vender a nosotros',
        body: 'Puedes revendernos tus diamantes al precio de compra que pagaste.'
      },
      {
        key: 'sellThirdParty',
        title: 'Vender a terceros',
        body: 'Puedes revender tus diamantes a terceros.'
      }
    ],
    footnote: '*DS-Plan significa plan Solution.'
  },
  tradWeg: {
    overline: 'Comercio tradicional',
    title: 'La vía tradicional',
    sub: 'Antes de que un diamante llegue al cliente final, se generan márgenes comerciales considerables a través de intermediarios, mayoristas y minoristas, frente al precio del diamante en bruto de la mina.',
    steps: [
      { title: 'Mina', subtitle: 'Diamantes en bruto' },
      { title: 'Intermediarios', subtitle: 'Compra de diamantes en bruto' },
      { title: 'Tallado', subtitle: 'Tallado a diamantes de joyería' },
      { title: 'Certificación', subtitle: 'por institutos reconocidos como GIA' },
      { title: 'Bolsa de diamantes', subtitle: 'Venta al mayorista' },
      { title: 'Mayorista', subtitle: 'Venta al minorista' },
      { title: 'Minorista', subtitle: 'p. ej., joyerías' },
      { title: 'Cliente final', subtitle: 'Compra de diamantes' }
    ]
  },
  stigWeg: {
    overline: 'STIG ROCK',
    title: 'La vía STIG ROCK',
    sub: 'Rompemos este círculo comprando los diamantes en bruto directamente de la mina, haciéndolos tallar y certificar por nuestros socios. De esta forma podemos transferir estos márgenes comerciales en forma de créditos de descuento a nuestros clientes.',
    duration: '12 meses — duración del DS-Plan',
    centerBig: '04',
    centerCaption: 'Hasta 4 ciclos comerciales durante la duración del DS-Plan',
    cycle: [
      { n: '1.', title: 'Compra de varios diamantes en bruto', body: 'para un DS-Plan' },
      { n: '2.', title: 'Tallar y certificar', body: 'por nuestros socios' },
      { n: '3.', title: 'Venta a clientes finales', body: 'y mayoristas' },
      { n: '4.', title: 'Repetir este proceso', body: 'hasta 4× al año' }
    ],
    steps: [
      { title: 'Mina', subtitle: 'Diamantes en bruto' },
      { title: 'Tallado', subtitle: 'por nuestros socios' },
      { title: 'Certificación', subtitle: 'por institutos reconocidos' },
      { title: 'Cliente final', subtitle: 'Compra y créditos de descuento' }
    ],
    footnote: '*DS-Plan significa plan Solution.'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'Paquetes VIP',
    sub: 'Válidos durante 12 meses para todos los planes Solution que contrates. Según el paquete VIP: +1% hasta +3% de descuento adicional',
    cardKicker: 'adicional – en todos',
    cardKicker2: 'los planes Solution',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Los descuentos se convierten en ahorros',
      body: 'Ahorro mensual en lugar de carga mensual. De los descuentos surgen ahorros — y estos pagan exactamente las cosas por las que de otro modo pagarías de tu propio bolsillo cada mes.',
      line1Label: 'DS-Plan desde',
      line1Value: '$5.000',
      line2Label: 'descuento mens.',
      line2Value: '3%',
      line3Label: 'Paquete VIP 3',
      line3Value: '+3%',
      resultLabel: 'ahorros mens.',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: '¿Cómo es posible?',
    title: 'Hemos redefinido la cadena de valor.',
    traditionalTitle: 'La vía tradicional',
    traditionalSteps: [
      'Mina — Diamantes en bruto',
      'Intermediarios — Compra',
      'Tallado — Tallado',
      'Certificación (GIA)',
      'Bolsa de diamantes — Mayorista',
      'Mayorista → Minorista',
      'Joyerías → Cliente final'
    ],
    traditionalNote: 'Antes de que un diamante llegue al cliente final, se generan márgenes comerciales considerables a través de intermediarios, mayoristas y minoristas.',
    stigTitle: 'La vía STIG ROCK',
    stigSteps: [
      'Compra directa — Diamantes en bruto de la mina',
      'Tallar y certificar por nuestros socios',
      'Venta a clientes finales y clientes B2B',
      'Hasta 4 ciclos comerciales al año'
    ],
    stigNote: 'Rompemos el círculo y transferimos los márgenes comerciales como créditos de descuento a nuestros clientes — hasta 4 ciclos comerciales durante la duración del DS-Plan.'
  },
  optionen: {
    overline: 'Tus opciones',
    title: 'Al finalizar tu plan Solution',
    items: [
      { title: 'Envío a domicilio', body: 'Diamantes (quilates) al precio de tu DS-Plan.' },
      { title: 'Vender a nosotros', body: 'Reventa al precio de compra que pagaste.' },
      { title: 'Vender a terceros', body: 'Comercializar diamantes en el mercado libre.' }
    ]
  },
  einfacherWeg: {
    overline: 'Planes Solution — una innovación de producto única',
    title: 'La vía sencilla',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Registro',
        body: 'Contacta con tu referente y crea una cuenta gratuita.'
      },
      { n: '02', icon: 'cart', title: 'Compra de un producto', body: 'Desde $250' },
      {
        n: '03',
        icon: 'discount',
        title: 'Recibir descuentos',
        body: 'Recibe créditos de descuento mensuales.'
      }
    ]
  },
  business: {
    overline: 'Tipos de bonificación',
    title: 'La forma más sencilla y justa.',
    sub: 'Cinco tipos de bonificación — para construir tu negocio con éxito.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Hasta nivel 3, desde categoría profesional Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Desde Sapphire — en profundidad infinita.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Sobre el Infinity Bonus – hasta nivel 5 · SIN cualificación.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 pools del volumen de negocio mundial.'
      },
      {
        name: 'Rank Bonus',
        icon: 'rank',
        value: '$8.325 mill.',
        desc: 'Bonificación única en diamantes (quilates).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Esta bonificación se te paga por cada nuevo plan Solution contratado hasta el nivel 3. Con cualificaciones muy bajas desbloqueas los niveles individuales.',
    total: 'Hasta 18% Unilevel Bonus',
    levels: [
      {
        level: 'Nivel 1',
        value: '10%',
        qual: 'desde el principio',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Nivel 2',
        value: '5%',
        qual: 'desde categoría profesional Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Nivel 3',
        value: '3%',
        qual: 'desde categoría profesional Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'A partir de la categoría profesional Sapphire estás cualificado para nuestro plan Infinity Bonus. Recibes un 3% de bonificación. Con cada nueva categoría profesional se añaden más porcentajes. Si un socio de tu equipo también está cualificado, recibes la diferencia de rango a rango.',
    exampleTitle: 'Ejemplo',
    exampleRows: [
      { label: 'Tú eres Blue Diamond', value: '12%' },
      { label: 'Tu socio es Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Tu Infinity Bonus', value: '9%' },
    totalNote: 'Total hasta 24% Infinity Bonus sobre todos los planes Solution contratados en tu equipo — en profundidad infinita.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Con esta bonificación te beneficias del éxito de tu equipo. Recibes un Matching Bonus del 5% sobre el Infinity Bonus de tus socios — y esto hasta el 5.º nivel de tu equipo.',
    note: 'Sobre todos los pagos de Infinity Bonus en tu equipo – hasta el nivel 5. Desde el principio – SIN cualificación.',
    levels: [
      { level: 'Nivel 1', value: '5%' },
      { level: 'Nivel 2', value: '5%' },
      { level: 'Nivel 3', value: '5%' },
      { level: 'Nivel 4', value: '5%' },
      { level: 'Nivel 5', value: '5%' }
    ],
    totalPrefix: 'Total hasta',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: 'El 3% del volumen de negocio mundial fluye a partes iguales en 3 pools diferentes. Al alcanzar determinadas categorías profesionales te cualificas para cada pool individual.',
    forever: 'Una vez alcanzado – ¡participación para SIEMPRE!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'desde Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'desde Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'desde Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Total',
    totalValue: '3%',
    totalSuffix: 'del volumen de negocio mundial'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rank Bonus',
    title: 'Rank Bonus',
    sub: 'A partir de la categoría profesional Diamond recibes un Rank Bonus. Este se paga en diamantes (quilates). Se trata de una bonificación única.',
    highlight: 'Diamantes (quilates) por un valor total de',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Categorías profesionales',
    title: 'Categorías profesionales',
    sub: 'Para alcanzar las respectivas categorías profesionales cuenta el volumen de negocio total histórico (HG). Este debe estar distribuido en varios equipos a partir del nivel Sapphire. Para alcanzar Ruby o superior necesitas al menos dos socios directos con un plan Solution.',
    forever: 'Una vez alcanzado – ¡confirmado para SIEMPRE!',
    footnote: 'HV = Volumen de negocio total histórico.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 socios dir.', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', 'Bonif. $5k' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', 'Bonif. $20k', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', 'Bonif. $50k', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', 'Bonif. $100k', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', 'Bonif. $150k', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', 'Bonif. $1M', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', 'Bonif. $2M', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', 'Bonif. $5M', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Emprende el camino con nosotros',
    title: 'El momento adecuado es justo ahora.',
    body: 'Este modelo de negocio establece nuevos estándares y reúne todos los factores de éxito para un negocio sostenible y exitoso a largo plazo. Regístrate hoy, elige tu plan Solution y aprovecha esta oportunidad de negocio única.',
    hint: 'Habla con la persona que te ha invitado a esta presentación — tiene un enlace de registro para ti.',
    formName: 'Nombre',
    formEmail: 'Email',
    formPhone: 'Teléfono',
    formSubmit: 'Ponerse en contacto',
    success: 'Gracias — nos pondremos en contacto de forma discreta y personal.',
    callCta: 'Llamar',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Aviso legal y disclaimer',
    disclaimer: 'Esta presentación es meramente informativa y no constituye asesoramiento financiero, de inversión ni fiscal. STIG ROCK no es un producto financiero, sino que se refiere a diamantes naturales como activos tangibles. No se garantiza ninguna revalorización, beneficio ni rendimiento. Los resultados pasados no son indicativos de resultados futuros. Todos los cálculos presentados en relación con las comisiones son meramente ilustrativos y tampoco constituyen garantía alguna. Los contenidos están sujetos a cambios — traducción libre (no es traducción oficial).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, EAU',
    copy: '© 2026 STIG International. Todos los derechos reservados.',
    version: 'Versión: DS-12-2025 V3'
  },
  misc: { next: 'Siguiente sección' }
};

export default es;
